/**
 * errorActions.js
 * Talkroute
 *
 * Created by Vel Genov on 2/13/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

/**
 * Constants for the different redux action types
 */
export const CLEAR_ERRORS = "CLEAR_ERRORS";

/**
 * An action to clear all errors
 */
export const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

const errorActions = {
  clearErrors,
};

export default errorActions;
